export const categories = [
  { id: "established", label: "Established Patient" },
  { id: "new", label: "New Patient" },
];

export const services = {
  new: [
    {
      id: "telehealth1",
      title: "Initial Consultation: Expanded Telehealth (1 hr)",
      price: 750,
      description: "This appointment will cover your primary concerns and implementing a treatment plan.",
    },
    {
      id: "ketamine",
      title: "Initial Consultation Ketamine/Wellness Visit by Telehealth",
      price: 500,
      description: "Includes review of recent laboratory results if available.",
    },
    {
      id: "longevity",
      title: "Initial Consultation: Longevity/Anti-Aging by Telehealth",
      price: 1000,
      description: "Covers anti-aging, longevity and treatment plan.",
    },
  ],
  established: [
    {
      id: "followup",
      title: "Follow-up Consultation (30 min)",
      price: 250,
      description: "For ongoing patients to continue their treatment plan.",
    },
  ],
};

export const timeSlots = [
  { date: "2025-10-01", slots: ["10:00 AM - 11:00 AM", "02:00 PM - 03:00 PM"] },
  { date: "2025-10-02", slots: ["10:00 AM - 11:00 AM"] },
  { date: "2025-10-07", slots: ["10:00 AM - 11:00 AM"] },
];

export const patientFields = [
  { name: "first_name", label: "First Name", type: "text", required: true },
  { name: "last_name", label: "Last Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "mobile", label: "Mobile", type: "number", required: true },
  { name: "dob", label: "Date of Birth", type: "date", required: true },
  { name: "gender", label: "Gender", type: "radio", required: true, options: ["male", "female"] },
  { name: "address_line1", label: "Address Line 1", type: "textarea", required: true },
  { name: "address_line2", label: "Address Line 2", type: "textarea", required: false },
  { name: "zip_code", label: "Zip Code", type: "number", required: true },
  { name: "country", label: "Country", type: "text", required: true},
  { name: "state", label: "State", type: "text", required: true },
  { name: "city", label: "City", type: "text", required: true },
];
